import React, { useEffect, useState } from 'react';
import { Routes, Route, Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { dataService } from '../../../Services/data/data.service';
import { toast } from 'react-toastify';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import WorkstationOverviewPage from '../Order/WorkstationOverviewPage';
import OrderOverviewPage from '../Order/OrderOverviewPage';
import HistoryPage from '../History/HistoryPage';
import UsersPage from '../Users/Users';
import PrivateRoute from '../Auth/PrivateRoute';
import LoginPage from '../Auth/Login';
import ServicesDashboardPage from '../Services/ServicesDashboardPage';
import TransportDashboardPage from '../Services/TransportDashboardPage';
import { systemParameters } from '../../../Config/constants';

import SettingsPage from './SettingsPage';
import HeaderBar from '../../Shared/HeaderBar';
import NavDrawer from '../../Shared/NavDrawer';

import Loading from '../../Shared/Loading';
import FlagstoneTheme from '../../../Config/flagstoneTheme';


export const IndexPage = (props) => {
  const classes = useStyles();
  const [dataFetched, setDataFetched] = useState(false);

  //loading
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");

  const setInitialState = () => {
    let neededSystemParameters = [systemParameters.VersionNumber, systemParameters.ServicesDashboardUrl, systemParameters.TransportDashboardUrl];

    Promise.all([
      dataService.getSystemParametersByIdList(neededSystemParameters)
    ]).then((results) => {
      if (!dataFetched) {
        let settings = results[0];
        props.actions.setSystemParameters(settings.data);
        setDataFetched(true);
      }
    }).catch((error) => { toast.error(error, { position: 'top-center' }) });
  }

  const handleLoading = (value, tempLoadingText) => {
    setLoading(value);
    setLoadingText(tempLoadingText);
  };

  useEffect(() => {
    if (!dataFetched) {
      setInitialState();
    }
  }, [dataFetched]);

  return (
    <React.Fragment>
      <React.Fragment>
        <HeaderBar className={classes.headerBar} actions={props.actions} {...props}></HeaderBar>
        <NavDrawer actions={props.actions} {...props}></NavDrawer>
      </React.Fragment>
      {loading && <Loading loadingText={loadingText} loading={loading}></Loading>}

      <main className={classes.content}>
        <Box className={classes.rootClass}
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bgr-logo.svg), linear-gradient(#EFEFEF,#FFFFFF)`, backgroundRepeat: "no-repeat", backgroundPosition: 'right bottom', backgroundSize: '40%,100%', width: "max-content", minWidth: "100%", zIndex: "0" }}
          sx={{
            marginTop: { xs: "0px", md: "50px" },
          }}
        >
          {/* <div className={classes.background}> */}
          {/* <IdleController {...props}></IdleController> */}
          {/* <Routes>
            <Route exact path="/" Component={() => <WorkstationOverviewPage {...props}></WorkstationOverviewPage>} />
            <Route path="/settings" Component={<SettingsPage i18n={props.i18n} ></SettingsPage>} />
            <Route path="/workstation" Component={(matchProps) => dataFetched ? <OrderOverviewPage  {...matchProps}  {...props} handleLoading={handleLoading}></OrderOverviewPage> : <React.Fragment></React.Fragment>} />
            <Route path="/history" Component={(matchProps) => dataFetched ? <HistoryPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></HistoryPage> : <React.Fragment></React.Fragment>} />
            <Route path="/users" Component={(matchProps) => dataFetched ? <UsersPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></UsersPage> : <React.Fragment></React.Fragment>} />
          </Routes> */}

          <Routes>
            <Route path="/login" element={<LoginPage {...props} />} />

            <Route exact path="/" Component={() => <WorkstationOverviewPage {...props}></WorkstationOverviewPage>} />
            <Route path="/settings" Component={<SettingsPage i18n={props.i18n} ></SettingsPage>} />
            <Route path="/workstation" Component={(matchProps) => dataFetched ? <OrderOverviewPage  {...matchProps}  {...props} handleLoading={handleLoading}></OrderOverviewPage> : <React.Fragment></React.Fragment>} />
            <Route path="/history" Component={(matchProps) => dataFetched ? <HistoryPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></HistoryPage> : <React.Fragment></React.Fragment>} />
            {/* <Route path="/users" Component={(matchProps) => dataFetched ? <UsersPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></UsersPage> : <React.Fragment></React.Fragment>} /> */}
            {/* Protect /users route with PrivateRoute */}
            <Route path="/services" Component={(matchProps) => dataFetched ? <ServicesDashboardPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></ServicesDashboardPage> : <React.Fragment></React.Fragment>} />
            <Route path="/transport" Component={(matchProps) => dataFetched ? <TransportDashboardPage  {...matchProps}  {...props} handleLoading={handleLoading} loading={loading}></TransportDashboardPage> : <React.Fragment></React.Fragment>} />
            <Route
              path="/users"
              element={
                <PrivateRoute user={props.nav.user}>
                  {dataFetched ? (
                    <UsersPage
                      {...props}
                      handleLoading={handleLoading}
                      loading={loading}
                    />
                  ) : (
                    <React.Fragment />
                  )}
                </PrivateRoute>
              }
            />

          </Routes>

          <div className={classes.footer}>
            <div className={classes.footer__version}>
              <div className={classes.powered}>Powered by Flagstone </div>
              {props.general.systemParameters.Results && props.general.systemParameters.Results !== null && props.general.systemParameters.Results !== undefined && props.general.systemParameters.Results.length > 0 &&
                <div className={classes.powered}>
                  {(props.general.systemParameters.Results.find(x => x.Id === systemParameters.VersionNumber) !== null && props.general.systemParameters.Results.find(x => x.Id === systemParameters.VersionNumber) !== undefined) && "v." + props.general.systemParameters.Results.find(x => x.Id === systemParameters.VersionNumber).Value}
                </div>
              }
            </div>
          </div>
        </Box>
      </main>

    </React.Fragment>
  )
}

const useStyles = makeStyles((theme) => ({

  backdrop: {
    zIndex: 100,
    color: '#fff',
    backgroundColor: '#EFEFEF'
  },

  rootClass: {
    display: 'flex',
    height: 'fit-content',
    minHeight: 'calc(100vh - 50px)',
    width: '100%',
    flexDirection: "column",
    justifyContent: "space-between",
    position: 'relative',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: '260px',
    width: `calc(100% - 260px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: "calc(100% - 50px)",
    height: 'calc(100% - 60px)',

    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 80px)',
      marginTop: '80px'

    },
    display: 'flex',
    flexDirection: "row"

  },

  footer: {
    display: "flex",
    justifyContent: "flex-end",

    // padding: "20px",
    // marginTop: "48px",
    // width: "100%",

    position: "absolute",
    bottom: "20px",
    right: "20px",

    boxSizing: "border-box",
  },

  footer__version: {
    width: "fit-content",
    boxSizing: "border-box",
  },

  powered: {
    height: "20px",

    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: 'Medium',
    color: FlagstoneTheme.palette.text.primary,
    opacity: "0.4",
    zIndex: "2",
    alignSelf: "flex-end"
  },

}));
function mapStateToProps(state) {
  return {
    general: state.general,
    workstation: state.workstation
  }
}

export default connect(mapStateToProps)(IndexPage)